import { GenericSuspense } from "@mzara/component";
import { Outlet } from "react-router-dom";

const FormationAdminContainer = () => {
    return (
        <GenericSuspense>
            <Outlet />
        </GenericSuspense>
    );
};

export default FormationAdminContainer;
